import { Module } from "vuex";
import { RootState } from "..";
import { actions } from "./invitation.actions";

export interface InvitationState {}

const state: InvitationState = {};

export const namespaceInvitation = "invitation";

export const invitationsModule: Module<InvitationState, RootState> = {
  namespaced: true,
  state,
  actions
};

export * from "./invitation.actions";
